export default "__VITE_ASSET__KUgju1Aa__"